import { InputNumber, Input } from "antd";
import React, { useState, useCallback } from "react";
import { formatPrice } from "../../utils/formatter";
import useLocale from "../../hooks/use-locale";

interface SingleQuantityProps {
  salesType: string;
  text: string;
  price: number;
  seatGroup: string | undefined;
  freeQuantity: number;
  onChangeQuantity: (value: number, salesType: string, text: string) => void;
}

const SingleQuantity: React.FC<SingleQuantityProps> = ({
  salesType,
  text,
  price,
  seatGroup,
  freeQuantity,
  onChangeQuantity,
}) => {
  const [value, setValue] = useState<number>(0);
  const [, translations] = useLocale();

  const onChange = useCallback((val) => {
    setValue(val);
    onChangeQuantity(val, salesType, text);
  }, []);

  const quantityType = !!seatGroup
    ? `${value}_${salesType}_${seatGroup}`
    : `${value}_${salesType}`;
  return (
    <div className="adt_quantity">
      <label className="title">{text}</label>
      <label className="price">{formatPrice(price)}</label>
      <div className="quantity buttons_added">
        <span className="screen-reader-text">{translations["third.qty_minus_label"]}</span>
        <button
          className="qty-button minus"
          onClick={() => onChange(Math.max(0, value - 1))}
          aria-label={translations["third.qty_minus"]}
          disabled={value <= 0}
        >
          -
        </button>
        <label 
          className="screen-reader-text"
          id={"label_" + quantityType}
          htmlFor={"qty_" + quantityType}
        >
          {translations["steps.quantity"] + " " + text}
        </label>
        <InputNumber
          size="large"
          id={"qty_" + quantityType}
          aria-labelledby={"label_" + quantityType}
          min={0}
          max={freeQuantity + value}
          value={value}
          onChange={onChange}
          controls={false}
          style={{ textAlign: "center" }}
        />
        <span className="screen-reader-text">{translations["third.qty_plus_label"]}</span>
        <button
          className="qty-button plus"
          onClick={() => onChange(Math.min(freeQuantity + value, value + 1))}
          aria-label={translations["third.qty_plus"]}
          disabled={value >= freeQuantity + value}
        >
          +
        </button>
      </div>
      <Input type="hidden" name="quantities[]" value={quantityType} />
    </div>
  );
};
export default SingleQuantity;
